import Config from '@config';
import {
  PrimaryDocumentOwner,
  primaryDocumentFilePath,
} from '@gasbi/shared/common/features/primaryDocuments';

export {
  PrimaryDocumentKinds,
  hasDocumentId,
} from '@gasbi/shared/common/features/primaryDocuments';
export type {
  PrimaryDocumentKind,
  PrimaryDocumentOwner,
} from '@gasbi/shared/common/features/primaryDocuments';

// GSB-8069: a document of a primary document is streamed by the API, not linked to storage. A plain link to this
// same-origin url carries the session cookie, and the API works in the session's active organization.
export const primaryDocumentFileUrl = (
  owner: PrimaryDocumentOwner,
  documentId: string,
) => `${Config.VITE_API_URL}${primaryDocumentFilePath(owner, documentId)}`;
